import { Address } from '@generated/gql/graphql';

const formatAddress = (address: Address) => {
  const {
    organisation,
    department,
    subBuilding,
    buildingName,
    buildingNumber,
    thoroughfare,
    dependentThoroughfare,
    dependentLocality,
    doubleDependentLocality,
    postTown,
    county,
    postcode,
  } = address;

  return [
    organisation,
    department,
    subBuilding,
    buildingName,
    buildingNumber,
    thoroughfare,
    dependentThoroughfare,
    dependentLocality,
    doubleDependentLocality,
    postTown,
    county,
    postcode,
  ]
    .filter((l) => Boolean(l))
    .map((l) => l?.trim())
    .join(', ');
};

export { formatAddress };
